var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFormatRemoveFormat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M22.793 19.138L2.238 3.617a.563.563 0 00-.773.082l-.344.416a.518.518 0 00.085.746l20.556 15.522a.563.563 0 00.773-.082l.344-.416a.518.518 0 00-.085-.746zM13.1 6.688l-.851 2.466 1.745 1.319L15.3 6.688h4.95V7.75c0 .294.246.532.55.532h.55c.303 0 .55-.238.55-.532V5.094a.541.541 0 00-.55-.531H7.05a.547.547 0 00-.487.297l2.42 1.828H13.1zm-.55 11.156h-1.1l.883-2.557-1.745-1.318-1.338 3.875h-1.1a.54.54 0 00-.55.53v.532c0 .293.247.531.55.531h4.4a.54.54 0 00.55-.531v-.531a.54.54 0 00-.55-.531z"
  }))));
}

export default SvgFormatRemoveFormat;